/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CameraEventFetchStatus = {
    Pending: 'Pending',
    Completed: 'Completed',
    Failed: 'Failed'
} as const;
export type CameraEventFetchStatus = typeof CameraEventFetchStatus[keyof typeof CameraEventFetchStatus];

